<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p57"><span><a href="#/Contents#rp57">SUMMER SQUASH SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Use any summer squash in this soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>4 medium zucchini, chopped</span></p>
<p class="hang"><span>1 cup peeled, cubed Idaho potato</span></p>
<p class="hang"><span>⅓ cup each: chopped shallots, green onions</span></p>
<p class="hang"><span>2 cloves garlic, minced</span></p>
<p class="hang"><span>4 cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>1 cup chopped kale or spinach</span></p>
<p class="hang"><span>1–½ teaspoons dried tarragon leaves</span></p>
<p class="hang"><span>¼–½ cup fat-free half-and-half or fat-free milk</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>Cayenne pepper, as garnish</span></p>
<p class="hang"><span>1½ cups Sourdough Croutons (½ recipe) (see <span href="#/Chapter131#p849c" title="Link target outside of Sample">p. 636</span>)</span></p>
<p class="normalt"><span><b>1.</b> Sauté zucchini, potato, shallots, green onions, and garlic in lightly greased saucepan until lightly browned, about 8 minutes. Add broth, kale, and tarragon. Heat to boiling; reduce heat and simmer, covered, until vegetables are tender, 10 to 15 minutes. Process soup in food processor or blender until smooth; stir in half-and-half and season to taste with salt and white pepper. Serve warm or chilled; sprinkle each of bowl soup with cayenne pepper and top with Sourdough Croutons.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 100</span></p>
<p class="per1"><span>% calories from fat: 7</span></p>
<p class="per1"><span>Protein (g): 3.8</span></p>
<p class="per1"><span>Carbohydrate (g): 20.6</span></p>
<p class="per1"><span>Fat (g): 0.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 65</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
<p class="normalt"><span><a id="page_44"></a><span class="small">VARIATION</span></span></p>
<p class="normala" id="p57a"><span><b>Squash and Fennel Bisque</b> — Make soup as above, adding 1 sliced fennel bulb and ½ cup sliced celery, and substituting spinach for kale. Omit tarragon. Thin with additional broth if necessary.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0238.vue?1ab7bfd0